"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.chipStyleOverride = exports.generateSelectedChipStylesWithIcon = exports.pendingChip = exports.errorChip = exports.selectedChip = exports.inputChip = exports.defaultChip = void 0;
/* ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️
 * Changing shared code can have unintended consequences for all brands.
 * Please double check with the team before making changes here.
 * If brand specific changes are needed, they should be made in the brand's theme file.
 */
var material_1 = require("@mui/material");
var resolveTypographyVariantStyles_1 = require("../utils/resolveTypographyVariantStyles");
var commonStyles = (_a = {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0.375rem 0',
        borderRadius: '8px',
        backgroundColor: 'transparent',
        gap: '0.5rem',
        width: 'min-content'
    },
    _a["& .MuiSvgIcon-root, & .".concat(material_1.chipClasses.icon)] = {
        width: '1.25rem',
        height: '1.25rem',
    },
    _a);
exports.defaultChip = {
    props: { variant: 'default' },
    style: function (_a) {
        var _b;
        var theme = _a.theme;
        return (__assign(__assign(__assign({}, commonStyles), (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'chipLabel')), (_b = { border: "1px solid var(--neutrals-800, ".concat(theme.palette.neutrals.tertiary, ")") }, _b["&.".concat(material_1.chipClasses.disabled)] = {
            color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
            borderColor: "var(--neutrals-700, ".concat(theme.palette.neutrals.disabled, ")"),
        }, _b['&:hover'] = {
            backgroundColor: "var(--primary-300, ".concat(theme.palette.primary.light, ")"),
            color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"),
        }, _b.color = "var(--text-tertiary, ".concat(theme.palette.text.tertiary, ")"), _b.borderColor = "var(--neutrals-800, ".concat(theme.palette.neutrals.tertiary, ")"), _b)));
    },
};
exports.inputChip = {
    props: { variant: 'input' },
    style: function (_a) {
        var _b;
        var theme = _a.theme;
        return (__assign(__assign(__assign({}, commonStyles), (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'chipLabel')), (_b = { border: "1px solid var(--neutrals-800, ".concat(theme.palette.neutrals.tertiary, ")") }, _b["&.".concat(material_1.chipClasses.disabled)] = {
            color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
            borderColor: "var(--neutrals-700, ".concat(theme.palette.neutrals.disabled, ")"),
        }, _b['&:hover'] = {
            backgroundColor: "var(--primary-300, ".concat(theme.palette.primary.light, ")"),
            color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"),
        }, _b.color = "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"), _b['&:active'] = {
            backgroundColor: "var(--background-light, ".concat(theme.palette.backgrounds.light, ")"),
        }, _b)));
    },
};
exports.selectedChip = {
    props: { variant: 'selected' },
    style: function (_a) {
        var _b;
        var theme = _a.theme;
        return (__assign(__assign(__assign({}, commonStyles), (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'chipLabel')), (_b = { border: "1px solid var(--neutrals-800, ".concat(theme.palette.neutrals.tertiary, ")") }, _b["&.".concat(material_1.chipClasses.disabled)] = {
            color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
            borderColor: "var(--neutrals-700, ".concat(theme.palette.neutrals.disabled, ")"),
        }, _b.color = "var(--secondary-500, ".concat(theme.palette.secondary.main, ")"), _b.backgroundColor = "var(--background-light, ".concat(theme.palette.backgrounds.light, ")"), _b.borderColor = "var(--secondary-500, ".concat(theme.palette.secondary.main, ")"), _b['&:hover'] = {
            color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"),
            backgroundColor: "var(--info-500, ".concat(theme.palette.info.main, ")"),
        }, _b['&:active'] = {
            backgroundColor: 'transparent',
        }, _b)));
    },
};
exports.errorChip = {
    props: { variant: 'error' },
    style: function (_a) {
        var _b;
        var theme = _a.theme;
        return (__assign(__assign(__assign({}, commonStyles), (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'chipLabel')), (_b = { border: "1px solid var(--neutrals-800, ".concat(theme.palette.neutrals.tertiary, ")") }, _b["&.".concat(material_1.chipClasses.disabled)] = {
            color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
            borderColor: "var(--neutrals-700, ".concat(theme.palette.neutrals.disabled, ")"),
        }, _b.color = "var(--error-700, ".concat(theme.palette.error.dark, ")"), _b.borderColor = "var(--error-700, ".concat(theme.palette.error.dark, ")"), _b['&:hover'] = {
            color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"),
            backgroundColor: "var(--error-300, ".concat(theme.palette.error.light, ")"),
        }, _b)));
    },
};
exports.pendingChip = {
    props: { variant: 'pending' },
    style: function (_a) {
        var _b;
        var theme = _a.theme;
        return (__assign(__assign(__assign({}, commonStyles), (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'chipLabel')), (_b = { border: "1px solid var(--neutrals-800, ".concat(theme.palette.neutrals.tertiary, ")") }, _b["&.".concat(material_1.chipClasses.disabled)] = {
            color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
            borderColor: "var(--neutrals-700, ".concat(theme.palette.neutrals.disabled, ")"),
        }, _b['&:hover'] = {
            backgroundColor: "var(--primary-300, ".concat(theme.palette.primary.light, ")"),
            color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"),
        }, _b.color = "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"), _b.borderColor = "var(--neutrals-800, ".concat(theme.palette.neutrals.tertiary, ")"), _b.backgroundColor = "var(--primary-300, ".concat(theme.palette.primary.light, ")"), _b)));
    },
};
var generateSelectedChipStylesWithIcon = function (ownerState, theme) {
    var _a;
    // Override the selected style of the root element if the chip has an icon
    if (ownerState.variant === 'selected' && Boolean(ownerState.icon)) {
        return _a = {
                display: 'flex',
                gap: '0 !important'
            },
            _a["& .".concat(material_1.chipClasses.icon)] = {
                color: "var(--secondary-500, ".concat(theme.palette.secondary.main, ")"),
            },
            _a;
    }
    return {};
};
exports.generateSelectedChipStylesWithIcon = generateSelectedChipStylesWithIcon;
exports.chipStyleOverride = {
    root: function (_a) {
        var ownerState = _a.ownerState, theme = _a.theme;
        return (__assign({}, (0, exports.generateSelectedChipStylesWithIcon)(ownerState, theme)));
    },
};
